module.exports = "/_next/static/images/LN-E-c6646cc5b0fa9d66344a3aabcb0b9eb7.png";